import { FC } from "react";
import { useMediaQuery } from "@mui/material";

import ContentTitle from "../ContentTitle";
import AccountButton from "./AccountButton";

import styles from "./styles.module.scss";

interface Props {
    title: string;
    icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    onClick?: () => void;
    optionalButton?: React.ReactNode;
    titleOptionalButtons?: React.ReactNode;
}

const Header: FC<Props> = ({
    title,
    icon: Icon,
    optionalButton,
    titleOptionalButtons,
}) => {
    const isMobile = useMediaQuery("(max-width: 1050px)");

    return (
        <>
            <div className={styles.header}>
                <div className={styles.header_up}>
                    <div className={styles.title}>
                        <ContentTitle label={title} Icon={Icon} />
                        {!isMobile && (
                            <div className={styles.title_optional_buttons}>
                                {titleOptionalButtons}
                            </div>
                        )}
                    </div>
                    <div className={styles.header_right}>
                        <div className={styles.right_optional_button}>
                            {optionalButton}
                        </div>
                        {!isMobile && <AccountButton />}
                    </div>
                </div>
                {isMobile && titleOptionalButtons && (
                    <div className={styles.title_optional_buttons}>
                        {titleOptionalButtons}
                    </div>
                )}
            </div>
        </>
    );
};

export default Header;
